import { getCanonicalPath } from './seoHelper';

/**
 * Generiert eine SEO-freundliche Route mit /de/ Präfix für interne Links
 * 
 * @param legacyPath Alter Pfad ohne /de/ Präfix
 * @returns Neuer Pfad mit /de/ Präfix
 */
export const getSeoRoute = (legacyPath: string): string => {
  // Bestimmte Pfade bleiben unverändert (z.B. externe Links, Anker, Assets)
  if (
    legacyPath.startsWith('http') || 
    legacyPath.startsWith('#') || 
    legacyPath.startsWith('/assets') ||
    legacyPath.startsWith('/images')
  ) {
    return legacyPath;
  }
  
  return getCanonicalPath(legacyPath);
};

/**
 * Angepasste Link-Props Hilfsfunktion für react-router Links
 * 
 * @param to Zielroute (kann Legacy-Format sein)
 * @returns Objekt mit konvertierter Route für to-Prop
 */
export const linkProps = (to: string) => ({
  to: getSeoRoute(to)
}); 